import { getLocation } from 'connected-react-router';
import { match } from 'react-router';
import { matchPath } from 'react-router-dom';
import { fork, select } from 'redux-saga/effects';

import ProcessScan from 'api/endpoints/processScan';
import ROUTES from 'app/routes/paths';
import { UiWithReleaseOrDraftProcessId } from 'app/routes/uiPathParams';
import ApiUrlParams from 'constants/apiUrlParams';

function* reFetchScanList() {
  const { query, pathname } = yield select(getLocation);

  const {
    params: { releaseOrDraftProcessId },
  }: match<UiWithReleaseOrDraftProcessId> = yield matchPath(pathname, {
    path: ROUTES.process.definition.services.scanning._(),
  });

  yield fork(ProcessScan.getAllScanConfigurations, {
    [ApiUrlParams.releaseOrDraftProcessId]: releaseOrDraftProcessId,
    ...query,
  });
}

export default reFetchScanList;
